import type { TTSVoice } from '@/shared/components/dialog/TtsDialog/TtsDialogContext';

/**
 * TTSVoice 의 사용자 표시 이름. preset 진입점이면 사용자가 부여한 preset 이름,
 * 그 외에는 locale 별 voice 이름. tts 미설정 시 fallback.
 *
 * locale 은 next-intl `useLocale()` 반환을 그대로 받기 위해 string 도 허용.
 * 'ko' 외에는 영문 voice 이름으로 fallback.
 */
export function formatTtsDisplayName(
  tts: TTSVoice | null | undefined,
  locale: 'ko' | 'en' | (string & {}),
  fallback = '--',
): string {
  if (!tts?.voice) return fallback;
  if (tts.presetName) return tts.presetName;
  return locale === 'ko' ? tts.voice.nameKorean : tts.voice.name;
}
